import { Injectable } from '@angular/core';
import { Route, PreloadingStrategy } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CustomPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // If route explicitly disables preload, skip it
    if (route.data && route.data.preload === false) {
      return of(null);
    }
    // Delay preloading by 3.5s after initial paint to prevent competing with LCP and TBT
    return timer(3500).pipe(switchMap(() => load()));
  }
}